import { SEARCH_PARAMS_CART_ID_KEY, SEARCH_PARAMS_CART_NAME_KEY } from '@components/ClientPortal/config';

export const getCartNameValue = () => {
  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.get(SEARCH_PARAMS_CART_NAME_KEY) || searchParams.get(SEARCH_PARAMS_CART_ID_KEY) || '';
};
